// extracted by mini-css-extract-plugin
export default {"accordion":"AccordionItem_accordion__t1VA1","title":"AccordionItem_title__RS-sN","content":"AccordionItem_content__7AUT+"};